
import { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { useAuth } from '@/lib/auth-context';
import { AppShell } from '@/components/layout';

export function DashboardLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const { user, isLoading, isAuthenticated } = useAuth();
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    if (isLoading) return;

    if (!isAuthenticated || !user) {
      setIsAuthorized(false);
      if (pathname !== '/login') {
        navigate('/login?redirect=' + encodeURIComponent(pathname), { replace: false });
      }
      return;
    }

    if (isAuthorized) return;

    const validRoles = ['admin', 'producer', 'moderator', 'prayer_partner', 'congregant'];
    if (!validRoles.includes(user?.role)) {
      navigate('/unauthorized', { replace: true });
      return;
    }

    setIsAuthorized(true);
  }, [isLoading, isAuthenticated, user, navigate, pathname, isAuthorized]);

  if (isLoading || !isAuthorized) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900">
        <div className="flex flex-col items-center gap-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600" />
          <p className="text-sm text-slate-500 dark:text-slate-400">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
